import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import type { RouterContext } from '@/router';
import Layout from '@/features/layout/Layout';
import { LoadingScreen } from '@/features/layout/LoadingScreen';

function NotFoundPage() {
  return (
    <div className='min-h-screen flex flex-col'>
      <header className='absolute px-8 py-10'>
        <img src='/dxc-logo.png' alt='DXC' className='h-8' width={195} height={39} />
      </header>
      <main className='flex flex-col flex-1 justify-center items-center px-6 max-w-xl text-center gap-10 mx-auto'>
        <h1 className='text-6xl font-bold'>404</h1>
        <h2 className='font-bold text-3xl'>Page not found.</h2>
        <p>
          The page you're looking for doesn't exist.{' '}
          <a href='/chat' className='text-primary hover:underline'>
            Go to TalentIQ
          </a>
        </p>
      </main>
    </div>
  );
}

function RootLayout() {
  return (
    <Layout>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position='bottom-left' />}
    </Layout>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
  pendingComponent: () => <LoadingScreen message='Loading...' />,
});
